import { Box, Flex, Menu, Text } from "@mantine/core"
import { useState } from "react";
import CommentsSection360 from "./CommentsSection360";
import { IconBell } from "@tabler/icons";


const CommentsMenu360 = (

  {chosenEvidence}
    :
    {chosenEvidence: any}
) => {

  const [opened,setOpened] = useState(false)

  const [comments, setComments] = useState<any>({});
 

  const [unreadNotificationsMap, setUnreadNotificationsMap] = useState<any[]>(
    []
  );

  const getUnreadNotificationsCountByRequest = (requestId: string) => {
    return (
      unreadNotificationsMap.find((request) => request._id == requestId)
        ?.unreadNotificationsCount || 0
    );
  };


  console.log('chosenEvidence comments menu')
  console.log(chosenEvidence)


  return (

    

    <Flex>
      <Menu 
        opened={opened} 
        onChange={setOpened}
        position="left" 
        withinPortal
        offset={35}
        closeOnItemClick={false}
        closeOnEscape={false}
        closeOnClickOutside={false}
        styles={{
          dropdown: {
            position: 'fixed',
            zIndex: 1000,
            top: '10px',
            /* height: '99%', */
            overflow: 'hidden'
          }
        }}>
        <Menu.Target>
          <Flex align="center" w="107px" mr="12px" sx={{ cursor: "pointer" }}>
            <Box>
              <IconBell size={15} color="#5C5CEB" />
            </Box>
            <Text ml="4px" fw={500} color="#5C5CEB" fz={12} lineClamp={1} >
                Activity
            </Text>
          </Flex>
        </Menu.Target>

        <Menu.Dropdown id="comments-menu-dropdown" p={0} m={0}>
          <Box h="100%" w={496} >
            <CommentsSection360 setOpened={setOpened} item={chosenEvidence}  />
          </Box>
        </Menu.Dropdown>
      </Menu>
    </Flex>
    
  )
}

export default CommentsMenu360